export default __webpack_public_path__ + "static/media/facebook.d4e9bea3.svg";